// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__-tLx_","title":"Images45_title__24D1J","images":"Images45_images__18Ivn"};